export const googleFonts = {
    Rubik: {
        name: "Rubik",
        fontFamily: "'Rubik', sans-serif",
        url: 'https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900',
        fontWeight: {
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold',
            800: 'Extra-bold',
            900: 'Black'
        }
    },
    Heebo: {
        name: "Heebo",
        fontFamily: "'Heebo', sans-serif",
        url: 'https://fonts.googleapis.com/css2?family=Heebo:wght@100..900',
        fontWeight: {
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold',
            800: 'Extra-bold',
            900: 'Black'
        }
    },
    Arimo: {
        name: "Arimo",
        fontFamily: "'Arimo', sans-serif",
        url: 'https://fonts.googleapis.com/css2?family=Arimo:ital,wght@0,400..700;1,400..700',
        fontWeight: {
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold',
            800: 'Extra-bold',
            900: 'Black'
        }
    },
    Varela: {
        name: "Varela Round",
        fontFamily: "'Varela Round', sans-serif",
        url: 'https://fonts.googleapis.com/css2?family=Varela+Round:ital,wght@0,300..800;1,300..800',
        fontWeight: {
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold',
            800: 'Extra-bold',
            900: 'Black'
        }
    },
    Assistant: {
        name: "Assistant",
        fontFamily: "'Assistant', sans-serif",
        url: 'https://fonts.googleapis.com/css2?family=Assistant:wght@200..800',
        fontWeight: {
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold',
            800: 'Extra-bold',
            900: 'Black'
        }
    },
    MPlus: {
        name: "M PLUS 1p",
        fontFamily: "'Assistant', sans-serif",
        url: 'https://fonts.googleapis.com/css2?family=M+PLUS+1p&display=swap',
        fontWeight: {
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold',
            800: 'Extra-bold',
            900: 'Black'
        }
    },
    FrankRuhlLibre: {
        name: "Frank Ruhl Libre",
        fontFamily: "'Frank Ruhl Libre', serif",
        url: 'https://fonts.googleapis.com/css2?family=Frank+Ruhl+Libre:wght@300..900',
        fontWeight: {
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold',
            800: 'Extra-bold',
            900: 'Black'
        }
    },
    AmaticSC: {
        name: "Amatic SC",
        fontFamily: "'Amatic SC', sans-serif",
        url: 'https://fonts.googleapis.com/css2?family=Amatic+SC:wght@400;700',
        fontWeight: {
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold'
        }
    },
    Tinos: {
        name: "Tinos",
        fontFamily: "'Tinos', serif",
        url: 'https://fonts.googleapis.com/css2?family=Tinos:ital,wght@0,400;0,700;1,400;1,700',
        fontWeight: {
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold'
        }
    },
    RubikBubbles: {
        name: "Rubik Bubbles",
        fontFamily: "'Rubik Bubbles', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Bubbles',
        fontWeight: {
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold'
        }
    },
    Fredoka: {
        name: "Fredoka",
        fontFamily: "'Fredoka', sans-serif",
        url: 'https://fonts.googleapis.com/css2?family=Fredoka:wght@300..700',
        fontWeight: {
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold'
        }
    },
    Cousine: {
        name: "Cousine",
        fontFamily: "'Cousine', monospace",
        url: 'https://fonts.googleapis.com/css2?family=Cousine:ital,wght@0,400;0,700;1,400;1,700',
        fontWeight: {
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold'
        }
    },
    Secular: {
        name: "Secular One",
        fontFamily: "'Secular One', sans-serif",
        url: 'https://fonts.googleapis.com/css2?family=Secular+One&display=swap',
        fontWeight: {
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold'
        }
    },
    Alef: {
        name: "Alef",
        fontFamily: "'Alef', sans-serif",
        url: 'https://fonts.googleapis.com/css2?family=Alef:wght@400;700&display=swap',
        fontWeight: {
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold'
        }
    },
    NotoSansHebrew: {
        name: "Noto Sans Hebrew",
        fontFamily: "'Noto Sans Hebrew', sans-serif",
        url: 'https://fonts.googleapis.com/css2?family=Noto+Sans+Hebrew:wght@100..900&display=swap',
        fontWeight: {
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold'
        }
    },
    SuezOne: {
        name: "Suez One",
        fontFamily: "'Suez One', sans-serif",
        url: 'https://fonts.googleapis.com/css2?family=Suez+One&display=swap',
        fontWeight: {
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold'
        }
    },
    DavidLibre: {
        name: "Bellefair",
        fontFamily: "'Bellefair', serif",
        url: 'https://fonts.googleapis.com/css2?family=Bellefair&display=swap',
        fontWeight: {
            400: 'Regular'
        }
    },
    MiriamLibre: {
        name: "Miriam Libre",
        fontFamily: "'Miriam Libre', sans-serif",
        url: 'https://fonts.googleapis.com/css2?family=Miriam+Libre:wght@400..700&display=swap',
        fontWeight: {
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold'
        }
    },
    BonaNova: {
        name: "Bona Nova",
        fontFamily: "'Bona Nova', serif",
        url: 'https://fonts.googleapis.com/css2?family=Bona+Nova:ital,wght@0,400;0,700;1,400&display=swap',
        fontWeight: {
            400: 'normal',
            700: 'normal'
        }
    },
    BonaNovaSC: {
        name: "Bona Nova SC",
        fontFamily: "'Bona Nova SC', serif",
        url: 'https://fonts.googleapis.com/css2?family=Bona+Nova+SC:ital,wght@0,400;0,700;1,400&display=swap',
        fontWeight: {
            400: 'Regular',
            700: 'Bold'
        }
    },
    IBMPlexSansHebrew: {
        name: "IBM Plex Sans Hebrew",
        fontFamily: "'IBM Plex Sans Hebrew', sans-serif",
        url: 'https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Hebrew:wght@100;200;300;400;500;600;700',
        fontWeight: {
            100: 'Regular',
            200: 'Regular',
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold'
        }
    },
    RubikDirt: {
        name: "Rubik Dirt",
        fontFamily: "'Rubik Dirt', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Dirt&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    RubikMoonrocks: {
        name: "Rubik Moonrocks",
        fontFamily: "'Rubik Moonrocks', sans-serif",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Moonrocks&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    Karantina: {
        name: "Karantina",
        fontFamily: "'Karantina', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Karantina:wght@300;400;700&display=swap',
        fontWeight: {
            300: 'normal',
            400: 'normal',
            700: 'normal'
        }
    },
    RubikScribble: {
        name: "Rubik Scribble",
        fontFamily: "'Rubik Scribble', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Scribble&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    Handjet: {
        name: "Handjet",
        fontFamily: "'Handjet', sans-serif",
        url: 'https://fonts.googleapis.com/css2?family=Handjet:wght@100..900&display=swap',
        fontWeight: {
            100: 'Regular',
            200: 'Regular',
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold',
            800: 'ExtraBold 800',
            900: 'Black 900'
        }
    },
    Solitreo: {
        name: "Solitreo",
        fontFamily: "'Solitreo', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Solitreo&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    RubikDoodleShadow: {
        name: "Rubik Doodle Shadow",
        fontFamily: "'Rubik Doodle Shadow', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Doodle+Shadow&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    RubikGlitchPop: {
        name: "Rubik Glitch Pop",
        fontFamily: "'Rubik Glitch Pop', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Glitch+Pop&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    Lunasima: {
        name: "Lunasima",
        fontFamily: "'Lunasima', sans-serif",
        url: 'https://fonts.googleapis.com/css2?family=Lunasima:wght@400;700&display=swap',
        fontWeight: {
            400: 'normal',
            700: 'normal'
        }
    },
    RubikWetPaint: {
        name: "Rubik Wet Paint",
        fontFamily: "'Rubik Wet Paint', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Wet+Paint&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    RubikGlitch: {
        name: "Rubik Glitch",
        fontFamily: "'Rubik Glitch', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Glitch&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    RubikLines: {
        name: "Rubik Lines",
        fontFamily: "'Rubik Lines', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Lines&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    RubikBrokenFax: {
        name: "Rubik Broken Fax",
        fontFamily: "'Rubik Broken Fax', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Broken+Fax&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    RubikMaps: {
        name: "Rubik Maps",
        fontFamily: "'Rubik Maps', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Maps&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    RubikDoodleTriangles: {
        name: "Rubik Doodle Triangles",
        fontFamily: "'Rubik Doodle Triangles', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Doodle+Triangles&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    NotoSerifHebrew: {
        name: "Noto Serif Hebrew",
        fontFamily: "'Noto Serif Hebrew', serif",
        url: 'https://fonts.googleapis.com/css2?family=Noto+Serif+Hebrew:wght@100..900&display=swap',
        fontWeight: {
            100: 'Regular',
            200: 'Regular',
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold',
            800: 'ExtraBold 800',
            900: 'Black 900'
        }
    },
    RubikDistressed: {
        name: "Rubik Distressed",
        fontFamily: "'Rubik Distressed', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Distressed&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    RubikIso: {
        name: "Rubik Iso",
        fontFamily: "'Rubik Iso', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Iso&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    RubikBeastly: {
        name: "Rubik Beastly",
        fontFamily: "'Rubik Beastly', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Beastly&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    NotoRashiHebrew: {
        name: "Noto Rashi Hebrew",
        fontFamily: "'Noto Rashi Hebrew', serif",
        url: 'https://fonts.googleapis.com/css2?family=Noto+Rashi+Hebrew:wght@100..900&display=swap',
        fontWeight: {
            100: 'Regular',
            200: 'Regular',
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold',
            800: 'ExtraBold 800',
            900: 'Black 900'
        }
    },
    RubikVinyl: {
        name: "Rubik Vinyl",
        fontFamily: "'Rubik Vinyl', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Vinyl&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    RubikPuddles: {
        name: "Rubik Puddles",
        fontFamily: "'Rubik Puddles', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Puddles&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    RubikSprayPaint: {
        name: "Rubik Spray Paint",
        fontFamily: "'Rubik Spray Paint', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Spray+Paint&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    Rubik80sFade: {
        name: "Rubik 80s Fade",
        fontFamily: "'Rubik 80s Fade', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+80s+Fade&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    RubikGemstones: {
        name: "Rubik Gemstones",
        fontFamily: "'Rubik Gemstones', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Gemstones&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    RubikBurned: {
        name: "Rubik Burned",
        fontFamily: "'Rubik Burned', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Burned&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    RubikPixels: {
        name: "Rubik Pixels",
        fontFamily: "'Rubik Pixels', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Pixels&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    RubikMarkerHatch: {
        name: "Rubik Marker Hatch",
        fontFamily: "'Rubik Marker Hatch', system-ui",
        url: 'https://fonts.googleapis.com/css2?family=Rubik+Marker+Hatch&display=swap',
        fontWeight: {
            400: 'normal'
        }
    },
    OpenSans: {
        name: "Open Sans Hebrew",
        fontFamily: "'open sans hebrew', arial",
        url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap",
        fontWeight: {
            300: 'Regular',
            700: 'Bold',
        }
    },
     Outfit: {
        name: "Outfit",
        fontFamily: "'Outfit', sans-serif",
        url: 'https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap',
        fontWeight: {
            100: 'Thin',
            200: 'Extra Light',
            300: 'Light',
            400: 'Regular',
            500: 'Medium',
            600: 'Semi-bold',
            700: 'Bold',
            800: 'Extra-bold',
            900: 'Black'
        }
    },
    Helvetica: {
        name: "Helvetica",
        fontFamily: "'Helvetica', 'Helvetica Neue', Arial, sans-serif",
        url: "",
        fontWeight: {
            300: 'Light',
            400: 'Regular',
            700: 'Bold',
        }
    }
};

export const HebrewFonts = [
    googleFonts.Outfit, 
    googleFonts.Rubik,
    googleFonts.Heebo,
    googleFonts.Arimo,
    googleFonts.Varela,
    googleFonts.Assistant,
    googleFonts.MPlus,
    googleFonts.FrankRuhlLibre,
    googleFonts.AmaticSC,
    googleFonts.Tinos,
    googleFonts.RubikBubbles,
    googleFonts.Fredoka,
    googleFonts.Cousine,
    googleFonts.Secular,
    googleFonts.Alef,
    googleFonts.NotoSansHebrew,
    googleFonts.SuezOne,
    googleFonts.DavidLibre,
    googleFonts.MiriamLibre,
    googleFonts.BonaNova,
    googleFonts.BonaNovaSC,
    googleFonts.IBMPlexSansHebrew,
    googleFonts.RubikDirt,
    googleFonts.RubikMoonrocks,
    googleFonts.Karantina,
    googleFonts.RubikScribble,
    googleFonts.Handjet,
    googleFonts.Solitreo,
    googleFonts.RubikDoodleShadow,
    googleFonts.RubikGlitchPop,
    googleFonts.Lunasima,
    googleFonts.RubikWetPaint,
    googleFonts.RubikGlitch,
    googleFonts.RubikLines,
    googleFonts.RubikBrokenFax,
    googleFonts.RubikMaps,
    googleFonts.RubikDoodleTriangles,
    googleFonts.NotoSerifHebrew,
    googleFonts.RubikDistressed,
    googleFonts.RubikIso,
    googleFonts.RubikBeastly,
    googleFonts.NotoRashiHebrew,
    googleFonts.RubikVinyl,
    googleFonts.RubikPuddles,
    googleFonts.RubikSprayPaint,
    googleFonts.Rubik80sFade,
    googleFonts.RubikGemstones,
    googleFonts.RubikPixels,
    googleFonts.RubikMarkerHatch,
    googleFonts.OpenSans
];